/* eslint-disable max-len */
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { MSG, PRICE, PURCHASE_STATUS, SORT_DATE_PUBLIC_AT, SYSTEM_PATH, TEXT } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import { FormatNumber, FullPagination, ReactNotifications } from '../../components';
import { URL_SOCKET_CARD, URL_SOCKET_PURCHASE, socket } from '../../core/utils/socket';
import { calculateCardInfo } from '../../core/utils/common';
import InfiniteScroll from 'react-infinite-scroll-component';
import { io } from 'socket.io-client';
import './style.scss'
import { Banner } from '../../components/Container/Banner';
import { BeatLoader } from 'react-spinners';
import LazyLoad from 'react-lazy-load';
import ChildrenCard from './components/ChildrenCard';
import { flowResult } from 'mobx';

const KEY_SHUFFLE_CARD = 2;

const ListCard = observer(() => {

    // other
    const navigate = useNavigate();

    // store
    const { 
        modalStore: { show, hide, openAlert }, 
        cardStore: { getAllCard, listCard, allCards, setAttrObservable, pagingInfinity, addCardToHold, updateCardRate, getCardForInfinity },
        authStore: { accountInfo },
        generalStore: { exchanges, tokens, getAllExchanges, getAllTokens }
    } = useStore();

    // state
    const [cacheData, setCacheData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [cacheDataLength, setCacheDataLength] = useState(0); 

    const { register, getValues, watch } = useForm({
        mode: 'onChange', defaultValues: {
            price: '0',
            sort: '2'
        }
    });
    const watchPrice = watch('price');
    const watchExchange = watch('exchangeId');
    const watchToken = watch('tokenId');
    const watchSort = watch('sort');

    // lifecycle
    useEffect(() => {
        const getData = async () => {
            setCacheDataLength(0);
            onFetchCardList({ page: 1, size: watchSort == 2 ? 60 : 12 });
        }
 
        getData();
        return () => {
            setAttrObservable('listCard', []);
        }
    }, [watchPrice, watchExchange, watchToken, watchSort])

    useEffect(() => {
        setCacheDataLength(cacheData.length);
    }, [cacheData.length])

    useEffect(() => {
        const socket = io(URL_SOCKET_CARD);

        socket.on('change-card-info', (arg) => {
            const { currentRate = 0, currencyRate = 0 } = arg;
            setCacheData(prevData => {
                const processData = prevData.map((card) => {
                    let exchange = card.exchange;

                    if (arg[exchange.code] && ( arg[exchange.code].key == card?.token?.symbol || arg[exchange.code].key == card?.token?.poolAddress)) {
                        return {
                            ...card,
                            currentRate: arg[exchange.code].rate,
                            variationRate: calculateCardInfo(arg[exchange.code].rate, currencyRate, card)?.variationRate
                        }
                    }

                    return card 
                })
                setAttrObservable('listCard', processData);

                return processData;
            })

            updateCardRate(arg);
        });

        socket.on('update-card-info', (arg) => {
            const { id, airdrop, baseRate, cardPrice, cardTypeId, image, publicAt, status } = arg;
            setCacheData(prevData => {
                const findIndex = prevData.findIndex(item => item?.id == id);
                if (findIndex !== -1) {
                    prevData[findIndex].airdrop = airdrop;
                    prevData[findIndex].baseRate = baseRate;
                    prevData[findIndex].cardPrice = cardPrice;
                    prevData[findIndex].cardTypeId = cardTypeId;
                    prevData[findIndex].image = image;
                    prevData[findIndex].publicAt = publicAt;
                    prevData[findIndex].status = status;
                }
                
                setAttrObservable('listCard', prevData);
                return prevData;
            })
        })

        socket.on('hold-card-success', (arg) => {
            const { cardId } = arg;
            if(cardId) {
                setCacheData(prevData => {
                    const findIndex = prevData.findIndex(item => item?.id == cardId);
                    if (findIndex !== -1) {
                        prevData[findIndex].isHolded = true
                    }
                    setAttrObservable('listCard', prevData);
                    return prevData;
                })
            }
        })

        return () => {
            socket.off('change-card-info');
            socket.off('update-card-info');
            socket.off('hold-card-success');
            socket.disconnect();
        };
    }, []);

    useEffect(() => {
        getAllExchanges({ size: -1, sortDir: 'asc', sortKey: 'id' });
        getAllTokens({ size: -1, sortDir: 'asc', sortKey: 'id' });
    }, []);

    // function
    const onFetchCardList = async (payload) => {
        const { price, sort } = getValues();
        await flowResult(getCardForInfinity({
            exchangeId: watchExchange || '',
            tokenId: watchToken || '',
            minPrice: PRICE[price]?.minPrice || null,
            maxPrice: PRICE[price]?.maxPrice || null,
            sortKey: SORT_DATE_PUBLIC_AT[sort]?.sortKey || 'public_at',
            sortDir: SORT_DATE_PUBLIC_AT[sort]?.sortDir || 'desc',
            isShuffle: SORT_DATE_PUBLIC_AT[sort]?.value || false,
            ...payload
        }, (data) => {
            setCacheData(data?.elements || []);
            setIsLoading(Boolean(data?.elements?.length > 0)); 
        }, false, true));
    }

    const onShow = (id) => {
        show({
            id: 'modal',
            isOpen: true,
            header: '確認',
            onCancel: () => hide(),
            children: (
                <div className='mg-b-20 pd-lr-20'>
                    <span>Holderに追加しますか？</span>
                    <div className='mg-t-20 d-flex align-items-center justify-content-center flex-gap-20 flex-wrap'>
                        <button className='btn btn-bg-cs-6 width-130 btn-bg-cs-6-bd-cs-1' onClick={() => hide()}>キャンセル</button>
                        <button className='btn btn-bg-cs-1 width-130 ' onClick={() => holderCard(id)}>追加 </button>
                    </div>
                </div>
            )
        })
    }

    const holderCard = async (id) => {
        hide();
        const res = await addCardToHold({ cardId: id });
        if (res) {
            ReactNotifications('success', MSG['inform.success.create']);
            navigate(SYSTEM_PATH.HOLDER)
        }

    }

    const onPageChange = (page) => {
        onFetchCardList({ page, size: 12 });
    }

    const fetchMoreData = () => {
        const { price, sort } = getValues();
        const cardIds = cacheData.map(item => item.id).join(',');
        if (SORT_DATE_PUBLIC_AT[sort]?.value && isLoading) {
            getCardForInfinity({
                exchangeId: watchExchange || '',
                tokenId: watchToken || '',
                minPrice: PRICE[price]?.minPrice || null,
                maxPrice: PRICE[price]?.maxPrice || null,
                sortKey: SORT_DATE_PUBLIC_AT[sort]?.sortKey || 'public_at',
                sortDir: SORT_DATE_PUBLIC_AT[sort]?.sortDir || 'desc',
                size: 60, 
                isShuffle: SORT_DATE_PUBLIC_AT[sort]?.value || false, 
                cardIds }, 
            (data) => {
                if (data.elements.length > 0) {
                    setCacheData(prevData => [...prevData, ...data.elements]);
                } else {
                    setIsLoading(false); 
                }
            }, true);
        }
    }
    // chilren components

    return (
        <div className='list-card-screen'>
            <Banner />
            <div className='w-full mg-t-40'>

                <form className='d-flex align-items-center justify-content-between flex-gap-20 flex-wrap list-card-list-select'>
                    <div className='d-flex align-items-md-center flex-gap-5 flex-wrap flex-md-row flex-column list-card-list-select-item'>
                        <div className='width-120 list-card-list-select-item-title'>カードリスト:</div>
                        <div className='d-flex flex-gap-16 flex-wrap'>
                            <select {...register('price')} className='width-170 select-custom height-45'>
                                {
                                    Object.keys(PRICE).map((key) => <option key={key} value={key}>{PRICE[key].label}</option>)
                                }
                            </select>
                            <select {...register('exchangeId')} className='width-170 select-custom height-45'>
                                <option value={''}>すべての取引所</option>
                                {
                                    exchanges?.length > 0 &&
                                            exchanges.map(e =>
                                                <option key={e?.id} value={e?.id} >{e?.name}</option>
                                            )
                                }
                            </select>
                            <select {...register('tokenId')} className='width-170 select-custom height-45'>
                                <option value={''}>すべてのトークン</option>
                                {
                                    tokens?.length > 0 &&
                                            tokens.map(e =>
                                                <option key={e?.id} value={e?.id} >{e?.name}</option>
                                            )
                                }
                            </select>
                        </div>
                        
                    </div>
                    <div className='d-flex  align-items-center  flex-gap-5 flex-wrap list-card-list-select-item'>
                        <div className='width-120 list-card-list-select-item-title'>並べ替え:</div>
                        <select {...register('sort')} className='width-170 select-custom height-45'>
                            <option value={KEY_SHUFFLE_CARD}>ランダム</option>
                            {
                                Object.keys(SORT_DATE_PUBLIC_AT).filter(key => key != KEY_SHUFFLE_CARD).map((key) => <option key={key} value={key}>{SORT_DATE_PUBLIC_AT[key].label}</option>)
                            }
                        </select>
                    </div>
                </form>

                <InfiniteScroll
                    dataLength={allCards.length}
                    next={fetchMoreData}
                    hasMore={isLoading}
                    loader={SORT_DATE_PUBLIC_AT[getValues('sort')]?.value && <BeatLoader color='#D1BA7A' className='text-center'/>}
                    endMessage={
                        allCards?.length > 0 ? 
                            <p className='text-center'>
                                <b>{TEXT.SEEN_IT_ALL}</b>
                            </p> : 
                            <></>
                    }
                >
                    <div className='row mg-t-16 list-item'>
                        {allCards?.length > 0 ? allCards.map((item) => {
                            if(SORT_DATE_PUBLIC_AT[watchSort]?.value && allCards?.length > 12) {
                                return (
                                    // eslint-disable-next-line max-len
                                    <LazyLoad key={item.id} className='d-flex align-items-center justify-content-center col-xl-4 list-item-wrapper col-md-6 col-sm-12 flex-wrap mg-b-24'>
                                        <ChildrenCard item={item} onShow={onShow} />
                                    </LazyLoad>
                                )
                            }
                            return (
                                // eslint-disable-next-line max-len
                                <div key={item.id} className='d-flex align-items-center justify-content-center col-xl-4 list-item-wrapper col-md-6 col-sm-12 flex-wrap mg-b-24'>
                                    <ChildrenCard item={item} onShow={onShow} />
                                </div>
                            )
                        }) :
                            <div className='d-flex align-items-center justify-content-center '>
                                <span className='fs-heading-normal font-bold text-color-cs-1'>{MSG['inform.no_data']}</span>
                            </div>
                        }
                    </div>
                </InfiniteScroll>
                {
                    !SORT_DATE_PUBLIC_AT[getValues('sort')]?.value && (
                        <div className='d-flex align-items-center justify-content-center '>
                            <FullPagination siblingCount={1}
                                totalRecords={pagingInfinity.totalRecord}
                                currentPage={pagingInfinity.page}
                                pageSize={pagingInfinity.size}
                                onPageChange={onPageChange}
                                previousLabel="«"
                                nextLabel="»" />
                        </div>
                    )
                }

            </div>
        </div>
    )
})

export default ListCard;